module.exports = __webpack_public_path__ + "img/img22.f09d0ffe.png";